import { render } from "./AddTreatment.vue?vue&type=template&id=760c71b0&scoped=true"
import script from "./AddTreatment.vue?vue&type=script&lang=js"
export * from "./AddTreatment.vue?vue&type=script&lang=js"

import "./AddTreatment.vue?vue&type=style&index=0&id=760c71b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760c71b0"]])

export default __exports__